import { Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import useBlogs from "../../services/LandingPage/useBlogs";
import BlogSection from "./BlogSection";
import authorImg from "../../images/LandingPageImage/Author_img.svg";
import fb from "../../images/LandingPageImage/FB.svg";
import twitter from "../../images/LandingPageImage/X-Twitter.svg";
import whatsapp from "../../images/LandingPageImage/Whatsapp.svg";
import yt from "../../images/LandingPageImage/Yt.svg";

const Post = () => {
  const { slug } = useParams();

  const {
    singleBlog,
    fetchBlogBySlug,
    fetchFeaturedBlogs,
    featuredBlogs,
    loading,
    error,
  } = useBlogs();

  useEffect(() => {
    if (slug) fetchBlogBySlug(slug);
  }, [slug]);

  useEffect(() => {
    fetchFeaturedBlogs();
  }, []);

  if (error) return <div className="text-center py-20">{error}</div>;

  return (
    <>
      <div className="bg-white min-h-screen">
        <div className="max-w-8xl mx-auto px-6 lg:px-16 py-10 grid lg:grid-cols-3 gap-10">
          {/* Main Content */}
          <div className="lg:col-span-2">
            {/* Shimmer */}
            {loading || !singleBlog ? (
              <div className="animate-pulse space-y-6">
                <div className="h-8 bg-gray-200 rounded w-3/4"></div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                  <div className="space-y-2">
                    <div className="h-4 bg-gray-200 rounded w-32"></div>
                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
                <div className="h-80 bg-gray-200 rounded-xl"></div>
                <div className="space-y-3">
                  <div className="h-4 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded"></div>
                  <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                </div>
              </div>
            ) : (
              <>
                {/* Title */}
                <h1 className="text-3xl font-bold text-green-900 mb-6">
                  {singleBlog.title}
                </h1>

                {/* Author + Social */}
                <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
                  {/* Author Section */}
                  <div className="flex items-center gap-4">
                    <img
                      src={authorImg}
                      alt="Author"
                      className="w-12 h-12 rounded-full object-cover"
                    />

                    <div className="flex flex-col text-sm">
                      <span className="font-medium text-gray-800">
                        {singleBlog.author}
                      </span>
                      <span className="text-gray-500">
                        On{" "}
                        {new Date(singleBlog.created_at).toLocaleDateString(
                          "en-GB",
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Social Icons */}
                  <div className="flex items-center gap-3">
                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={fb} alt="Facebook" className="w-7 h-7" />
                    </a>

                    <a
                      href={`https://twitter.com/share?url=${window.location.href}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={twitter} alt="Twitter" className="w-7 h-7" />
                    </a>

                    <a
                      href={`https://wa.me/?text=${window.location.href}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={whatsapp} alt="WhatsApp" className="w-7 h-7" />
                    </a>

                    <a
                      href="https://www.youtube.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={yt} alt="YouTube" className="w-7 h-7" />
                    </a>
                  </div>
                </div>

                {/* Featured Image */}
                <img
                  src={singleBlog.image}
                  alt=""
                  className="w-full rounded-xl mb-8"
                />

                {/* Blog Content */}
                <div
                  className="prose prose-lg max-w-none"
                  dangerouslySetInnerHTML={{
                    __html: singleBlog.post_content,
                  }}
                />

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mt-8">
                  {singleBlog.post_keywords?.split(",").map((tag, i) => (
                    <span
                      key={i}
                      className="bg-gray-100 px-3 py-1 rounded-full text-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Share Section Bottom */}
                <div className="mt-10">
                  <h3 className="text-lg font-semibold mb-3">
                    Share this article
                  </h3>

                  <div className="flex gap-3">
                    <img src={fb} alt="" className="w-7 h-7" />
                    <img src={twitter} alt="" className="w-7 h-7" />
                    <img src={whatsapp} alt="" className="w-7 h-7" />
                    <img src={yt} alt="" className="w-7 h-7" />
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Sidebar */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Featured Posts</h3>

            <div className="space-y-4">
              {featuredBlogs.map((item) => (
                <div key={item.id} className="flex gap-3 border-b pb-3">
                  <img
                    src={item.image}
                    alt=""
                    className="w-34 h-24 object-cover rounded"
                  />
                  <div>
                    <p className="text-sm font-medium line-clamp-2">
                      {item.title}
                    </p>
                    <Link
                      to={`/blogs/${item.post_slug}`}
                      className="text-green-600 text-sm"
                    >
                      Read more →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <BlogSection />
    </>
  );
};

export default Post;
